import styled from 'styled-components';

const SectionHead = styled.div`
  background-color: ${(props): string => props.theme.colors.iceGray};
  padding: ${(props): string =>
    `${props.theme.spaces.md} ${props.theme.spaces.xl}`};
`;

export { SectionHead };
